export default __webpack_public_path__ + "static/media/transfer_process.c774fc44.png";